import { getSubscription } from "./getters";
import type { Subscriptions } from "./types";

export const isAlreadySubscribed = (id: keyof Subscriptions) => getSubscription(id) !== undefined;
